/** Title Case for dashboard section/panel headings (Executive Dashboard style). */

const SMALL_WORDS = new Set([
  "a",
  "an",
  "and",
  "as",
  "at",
  "but",
  "by",
  "for",
  "in",
  "of",
  "on",
  "or",
  "the",
  "to",
  "vs",
  "with",
]);

const ACRONYM_MAP = {
  osh: "OSH",
  apaar: "APAAR",
  aadhaar: "Aadhaar",
  ctet: "CTET",
  ai: "AI",
  kpi: "KPI",
  udise: "UDISE",
  tri: "TRI",
  tqi: "TQI",
  gpi: "GPI",
  nep: "NEP",
  mdm: "MDM",
  wash: "WASH",
  ger: "GER",
  pat: "PAT",
  sqaf: "SQAF",
  cwsn: "CWSN",
  mbu: "MBU",
  beo: "BEO",
  sla: "SLA",
  ct: "CT",
  ops: "Ops",
  infra: "Infra",
};

const capitalizePart = (part, isFirstWord) => {
  if (!part) return part;
  if (part === "&") return "&";

  const lower = part.toLowerCase();
  if (ACRONYM_MAP[lower]) return ACRONYM_MAP[lower];
  if (/^[A-Z]{2,}\d*$/.test(part)) return part;
  if (!isFirstWord && SMALL_WORDS.has(lower)) return lower;

  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

const titleCaseWord = (word, isFirstWord) => {
  if (!word) return word;
  if (word.includes("-")) {
    return word
      .split("-")
      .map((part, index) => capitalizePart(part, isFirstWord && index === 0))
      .join("-");
  }
  return capitalizePart(word, isFirstWord);
};

const titleCaseSegment = (segment, isFirstSegment = false) =>
  segment
    .split(/\s+/)
    .map((word, index) => titleCaseWord(word, isFirstSegment && index === 0))
    .join(" ");

export const toTitleCase = (text) => {
  if (!text || typeof text !== "string") return text;
  const trimmed = text.trim();
  if (!trimmed) return text;

  return trimmed
    .split(/(\([^)]*\))/g)
    .map((part, index) => {
      if (!part) return part;
      if (part.startsWith("(") && part.endsWith(")")) {
        const inner = part.slice(1, -1);
        return `(${titleCaseSegment(inner, true)})`;
      }
      return titleCaseSegment(part, index === 0);
    })
    .join("");
};
